var EventTypes = {
  PHOTO_STORE_PHOTOS_CHANGE: 'PHOTO_STORE_PHOTOS_CHANGE',
  PHOTO_STORE_SINGLE_PHOTO_CHANGE: 'PHOTO_STORE_SINGLE_PHOTO_CHANGE',
  PHOTO_STORE_SINGLE_PHOTO_ERROR: 'PHOTO_STORE_SINGLE_PHOTO_ERROR'
};

module.exports = EventTypes;
